import styled from "styled-components";

export const ScrollableContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow-y: auto;
  max-height: 100%;
  padding: 10px;
`;

export default ScrollableContainer;
